import React from "react";

type StoreCardSkeletonProps = {};

export const StoreCardSkeleton = ({}: StoreCardSkeletonProps) => {
    return <li className={"store-card store-card--skeleton"} />;
};
